import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Select } from '@lyearn/ui';
import { getSelectOptionLabel } from '@/components/Form/components/Select/getOptionLabel';

import { FilterInputProps } from '../types';
import { getSelectOptions } from './utils';

const FilterInputCheckBox = (props: FilterInputProps) => {
  const { value, onChange } = props;

  const { t } = useTranslation();

  const options = getSelectOptions(t);

  if (!value) {
    onChange(options[0].value);
  }

  return (
    <Select
      disableClearable
      getOptionLabel={getSelectOptionLabel}
      options={options}
      size="medium"
      value={value || options[0].value}
      onChange={onChange}
    />
  );
};

export default FilterInputCheckBox;
